export default __webpack_public_path__ + "static/media/skillinsightloader.0dfc531b.gif";